import React from 'react'
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Form, Field } from 'react-final-form'

export default function UiDatePicker(props) {
    const { label, name, placeholder } = props;

    return (

        <Field
            name={name}
            render={({ input, meta, ...rest }) => {
                return (
                    <>
                        <label className='sba-telerik-label'>{label}</label>
                        <DatePicker                         
                            {...input}
                            {...rest}
                            placeholder={placeholder}
                        />
                        {meta.error && <span className="k-required">{meta.error}</span>}
                    </>
                )
            }}
        />
    )
}
